import { RouterProps, withRouter } from 'react-router';
import * as React from 'react';
import Footer from '../App/components/Layout/Footer/Footer';
import Header from '../App/components/Layout/Header/Header';
import MainNavigation from '../App/components/Layout/MainNavigation/MainNavigation';
import ContentFragmentContainer from '../App/modules/ContentFragment/containers/ContentFragment/ContentFragmentContainer';
import withRouteMetadata from '../App/hocs/withRouteMetadata';
import BaseRoute from './_BaseRoute';



class TermsAndConditionsRoute extends BaseRoute {
	public static async getInitialProps (state: any) {
		const reduxData = await ContentFragmentProps(state, "app_usage_terms");

		return { reduxData };
	}

	public render () {

		return (
			<div>
				<Header />
				<MainNavigation />

				<ContentFragmentContainer
					fragmentKey="app_usage_terms"
					pageTitle="Nutzungsbedingungen"
				/>

				<Footer />
			</div>
		);
	}
}

export default withRouter(
	withRouteMetadata(
		TermsAndConditionsRoute,
		`termsAndConditions`,
		{
			metaTitle: `Allgemeine Nutzungsbedingungen | Aktionsfinder`,
			metaDescription: `Die Nutzungsbedigungen der Aktionsfinder GmbH auf einen Blick » Hier klicken und über alle Einzelheiten informieren.`,
		} as IRouteMetadataSetterType
	)
);